import {Component} from "../Component";
import {FormComponent} from "../FormComponent";
import {createLogger} from "../../util/logger";
import {InvitationsTable} from "./InvitationsTable";
import {AjaxNavigation} from "../AjaxNavigation";
import {Dialog} from "../Dialog";
import gsap from "gsap";
const console = createLogger("MemberArea");

export class MemberArea extends Component {
    static name = "member-area";

    get name() {
        return MemberArea.name;
    }

    constructor(el) {
        super(el);

        /**
         * @type {HTMLFormElement}
         */
        this.$createInvitationForm = this.$("createInvitationForm");
        this.$invitationsTable = this.$("invitationsTable");
        this.$deleteAccountDialog = this.$("deleteAccountDialog");

        this.$deleteAccountForm = this.$deleteAccountDialog?.querySelector("form");

        if (this.$deleteAccountForm) {
            this.deleteAccountForm = new FormComponent(this.$deleteAccountForm, {
                onSubmit: this.onSubmitDelete.bind(this),
            });
        }

        this.itemsPerPage = parseInt(this.$invitationsTable?.getAttribute("data-items-per-page"));

        /**
         * Get reference to site header to retrieve its height later on when scrolling elements into view
         * @type {HTMLElement}
         */
        this.$siteHeader = document.querySelector(".site-header");

        /**
         * @type {HTMLElement[]}
         */
        this.$tabs = this.querySelectorAll(".tab");
        this.$tabLinks = this.querySelectorAll("[data-tab-target]");

        this.addEventListener(this.$tabLinks, "click", (e) => {
            e.preventDefault();
            e.stopPropagation();

            this.$tabLinks.forEach(l => l.classList.remove("active"));
            e.currentTarget.classList.add("active");

            const targetId = e.currentTarget.getAttribute("data-tab-target").slice(1);

            this.$tabs.forEach((tab) => {
                if (tab.id === targetId) {
                    tab.style.display = "block";

                    window.scroll({
                        behavior: "smooth",
                        top: tab.offsetTop - this.$siteHeader.offsetHeight,
                    });
                } else {
                    tab.style.display = "none";
                }
            });

        });

        if (isNaN(this.itemsPerPage)) {
            this.itemsPerPage = 10;
        }

        this.addEventListener(this.$createInvitationForm?.querySelector("[type=file]"), "change", () => {
            this.$createInvitationForm.requestSubmit();
        });
        this.addEventListener(this.$createInvitationForm, FormComponent.EVENT_SUCCESS, this.onCreateInvitation.bind(this));
    }

    /**
     * Adds newly created invitation to table
     * @param e
     */
    onCreateInvitation(e) {
        console.log("onCreateInvitation", e, InvitationsTable.findComponentInTree(this.$invitationsTable, InvitationsTable));
        InvitationsTable.findComponentInTree(this.$invitationsTable, InvitationsTable)?.refresh();
    }


    /**
     * Submit listener to redirect to login after successfull delete account
     *
     * @param {Record<string, any>} res
     * @return Promise<any>
     *
     */
    onSubmitDelete(res) {
        console.log("onSubmitDelete", res.redirect_url);

        if (res.redirect_url) {
            Dialog.getInstance(this.$deleteAccountDialog)?.close();
            AjaxNavigation.navigate(res.redirect_url);
        }
        return Promise.resolve();
    }

    destroy() {
        super.destroy();
        console.log("destroy");
    }


}

